export interface MyOrdersResponse {
    nextPage: string;
    totalCount: number;
    filteredCount: number;
    filterHTML: string;
    debug: number;
    items: MyOrdersItem[] | null;
    error: number;
    code: number;
    message: string;
    multipleMachines: {
        label: string;
        tooltipContent: string;
    };
}

export interface MyOrdersStatus {
    type: string;
    text: string;
}

export interface MyOrdersItem {
    status: MyOrdersStatus | null;
    orderNumber: string;
    date: string;
    entryPoint: string;
    position: string;
    orderSum: string;
    machineNumber: string | [];
    detailLink: string;
}
